'use client';

import { useEffect, useRef } from 'react';
import RegistrationForm from './RegistrationForm';

export default function FinalCTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach(el => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-28 md:py-36 px-4 md:px-6 relative overflow-hidden"
      style={{ background: '#0C0A0E' }}>
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full"
          style={{ background: 'radial-gradient(ellipse, rgba(232,49,90,0.15) 0%, transparent 70%)' }} />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto">

        {/* Large CTA block */}
        <div className="reveal rounded-4xl overflow-hidden relative"
          style={{ background: 'linear-gradient(135deg, #1A0D14 0%, #1E1823 50%, #1A0D14 100%)', border: '1px solid rgba(232,49,90,0.25)', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>

          <div className="diagonal-rays absolute inset-0 opacity-20" />

          <div className="relative z-10 grid lg:grid-cols-2 gap-0">
            {/* Left: Copy */}
            <div className="p-12 md:p-16 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full text-xs font-semibold mb-8 w-fit"
                style={{ background: 'rgba(232,49,90,0.15)', border: '1px solid rgba(232,49,90,0.3)', color: '#FF8CA8', boxShadow: '0 4px 16px rgba(232,49,90,0.2)' }}>
                <span className="w-2.5 h-2.5 rounded-full online-dot" style={{ background: '#E8315A' }} />
                Jetzt kostenlos starten
              </div>

              <h2 className="font-display text-4xl md:text-6xl font-bold text-white leading-tight mb-7">
                Dein perfektes<br />
                <span className="text-gradient italic">Match wartet</span><br />
                auf dich.
              </h2>

              <p className="text-lg font-light leading-relaxed mb-10"
                style={{ color: 'rgba(245,240,247,0.6)' }}>
                Gerade sind <span className="font-semibold text-white">1.247 Singles</span> aus deiner Region aktiv. Warte nicht länger — melde dich jetzt kostenlos an.
              </p>

              {/* Benefits checklist */}
              <ul className="space-y-4">
                {[
                  'Kostenlose Registrierung in 2 Minuten',
                  'Keine versteckten Kosten beim ersten Kontakt',
                  'Lokale Matches aus deiner Postleitzahl',
                  'Verifizierte Profile, kein Catfishing',
                ]?.map((item, i) => (
                  <li key={i} className="flex items-center gap-4 text-base font-medium"
                    style={{ color: 'rgba(245,240,247,0.75)' }}>
                    <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-sm"
                      style={{ background: 'rgba(232,49,90,0.25)', color: '#E8315A', boxShadow: '0 4px 12px rgba(232,49,90,0.2)' }}>
                      ✓
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Form */}
            <div className="p-12 md:p-16 flex items-center"
              style={{ borderLeft: '1px solid rgba(255,255,255,0.08)' }}>
              <div className="w-full">
                <RegistrationForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}